<h2 mat-dialog-title>Welcome to Fruitage</h2>
<mat-dialog-content>
  <p class="dialog-description">
    Fruitage organizes discussions, goals, and tasks around your family workspace. Create a new family or request access
    with the 6-character code a parent shares with you.
  </p>

  <mat-tab-group>
    <mat-tab label="Create family">
      <form [formGroup]="createForm" class="dialog-form" (ngSubmit)="createFamily()">
        <mat-form-field appearance="fill">
          <mat-label>Family name</mat-label>
          <input matInput formControlName="name" placeholder="The Gatherings" />
          <mat-error *ngIf="createForm.controls.name.hasError('required')">Family name is required</mat-error>
        </mat-form-field>
        <button mat-flat-button color="primary" type="submit" [disabled]="busy()">Create</button>
      </form>
    </mat-tab>
    <mat-tab label="Join family">
      <form [formGroup]="joinForm" class="dialog-form" (ngSubmit)="joinFamily()">
        <mat-form-field appearance="fill">
          <mat-label>Invite code</mat-label>
          <input matInput formControlName="code" placeholder="ABC123" />
          <mat-error *ngIf="joinForm.controls.code.hasError('required')">Invite code is required</mat-error>
        </mat-form-field>
        <p class="join-note">A parent must approve your request before you can access their workspace.</p>
        <button mat-flat-button color="primary" type="submit" [disabled]="busy()">Join</button>
      </form>
    </mat-tab>
  </mat-tab-group>

  <div class="error" *ngIf="error() as err">
    <mat-icon>error_outline</mat-icon>
    <span>{{ err }}</span>
  </div>
</mat-dialog-content>
